import { render } from "./ProductLoader.vue?vue&type=template&id=48328129&scoped=true"
import script from "./ProductLoader.vue?vue&type=script&lang=js"
export * from "./ProductLoader.vue?vue&type=script&lang=js"

import "./ProductLoader.vue?vue&type=style&index=0&id=48328129&lang=scss&scoped=true"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48328129"]])

export default __exports__